var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.5834 6.98407C18.312 6.23212 19.0352 4.47759 15.9996 6.6081C11.6864 9.67991 7.43519 12.5638 7.43519 12.5638C6.99758 12.7679 6.5245 12.8788 6.04435 12.8896C5.56419 12.9003 5.08688 12.8108 4.6411 12.6264C2.81973 12.0624 0.693474 11.3105 0.693474 11.3105C0.693474 11.3105 -0.758345 10.3692 1.72691 9.3666C1.72691 9.3666 12.2341 4.91622 15.8781 3.3483C17.2746 2.72168 22.0115 0.71649 22.0115 0.71649C22.0115 0.71649 24.1984 -0.162142 24.0162 1.96973C23.9555 2.847 23.4698 5.92018 22.9842 9.24128C22.2543 13.9423 21.465 19.0833 21.465 19.0833C21.465 19.0833 21.3436 20.5246 20.3115 20.7752C19.2066 20.7559 18.1391 20.3593 17.2759 19.6472C17.033 19.4593 12.7211 16.6382 11.1413 15.2596C10.9806 15.1472 10.85 14.9947 10.7618 14.8163C10.6735 14.6378 10.6304 14.4393 10.6364 14.239C10.6425 14.0388 10.6975 13.8434 10.7964 13.671C10.8953 13.4985 11.0348 13.3548 11.202 13.2531C13.3929 11.1852 16.0049 8.61466 17.5834 6.98407Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTel);
export default __webpack_public_path__ + "static/media/footerTel.0ab6d6aaf07fcffa396dc5dfe661ede2.svg";
export { ForwardRef as ReactComponent };